import React from "react";
import { Routes, Route } from "react-router-dom";
import Search from "../../pages/search";
import DetailPage from "../../pages/details";
import Intro from "../intro/intro";
import { DigitalLibrary } from "../digitalLibrary/digitalLibrary";

function RoutesPage() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<Intro />} />

        <Route exact path="/search-bar" element={<Search />} />
        <Route exact path="/details" element={<DetailPage />} />
        <Route exact path="/digital-library" element={<DigitalLibrary />} />
      </Routes>
    </>
  );
}
export default RoutesPage;
